import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildSegmentRatingsPath, TypeRankingsFeaturesModel } from 'client/data/models/type-rankings-features';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { getBestSegmentRating } from 'site-modules/shared/utils/core-page/rating-and-ranking';

function HeadingTextSummaryUI({ className, segmentRating, hasEditorialRating }) {
  let firstSentence;
  switch (true) {
    case !!segmentRating: {
      firstSentence = `We tested this ${segmentRating.editorialSegment.edmundsTypeCategory} with ${segmentRating.editorialSegment.segmentRatings.length - 1} others.`;
      break;
    }
    case hasEditorialRating: {
      firstSentence = `We tested it along with its competitors.`;
      break;
    }
    default: {
      firstSentence = null;
    }
  }

  return (
    <p className={classnames('heading-text-summary', className)}>
      {firstSentence} Let us help you decide if it’s right for you.
    </p>
  );
}

HeadingTextSummaryUI.propTypes = {
  className: PropTypes.string,
  segmentRating: TypeRankingsEntities.SegmentRating,
  hasEditorialRating: PropTypes.bool,
};

HeadingTextSummaryUI.defaultProps = {
  className: null,
  segmentRating: null,
  hasEditorialRating: false,
};

export const HeadingTextSummary = connectToModel(HeadingTextSummaryUI, {
  segmentRating: bindToPath(
    ({ params: { make, model, year }, isUsed }) =>
      !isUsed && buildSegmentRatingsPath({ makeSlug: make, modelSlug: model, year }),
    TypeRankingsFeaturesModel,
    getBestSegmentRating
  ),
});
